<div class="content">

  <app-menu></app-menu>

  <div class="container-fluid">
    <app-header></app-header>

    <!-- content -->
    <div class="container-fluid page">
      
      <div class="tabs">
        <div *ngFor="let tab of tabService.tabs; let i = index" 
             (click)="onTabChange(i)" 
             [class.active]="i === tabService.activeTabIndex"
             class="tab">
          {{ tab.title }} 
          <i class="fa fa-times close-btn" (click)="closeTab(i)"></i>
        </div>
      </div>
      <div class="tab-content">
        <!-- <ng-container *ngFor="let tab of tabService.tabs; let i = index">
          <div [id]="tab.id" [class.active]="i === tabService.activeTabIndex" [class.tab-pane]="i !== tabService.activeTabIndex" class="content"> -->
            
              <!-- {{tab.id}} -->
              <!-- <router-outlet [name]="tab.id"></router-outlet> -->
              <router-outlet ></router-outlet>
            
            <!-- <div style="display: none;">
              <router-outlet>
                <div>
                  aqui
                </div>
              </router-outlet>
            </div> -->
          <!-- </div>
        </ng-container> -->
      </div>
      

    </div>
    <!-- / content -->
    </div>
  </div>
  
